import { render } from "./RedeemButton.vue?vue&type=template&id=1c9c0413&scoped=true"
import script from "./RedeemButton.vue?vue&type=script&lang=js"
export * from "./RedeemButton.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9c0413"]])

export default __exports__